import Axios from 'axios'
import { loginURL, messageUnreadCountURL } from '../api/http';
const state = {
  user: null,
  isLogin: false,
  unReadCount: 0,
  isHidden: true
}
const getters = {
  unReadCount: state => state.unReadCount,
  isHidden: state => state.isHidden,
}
const mutations = {
  SET_UNREAD_COUNT (state, count) {
    state.unReadCount = count
  },
  SET_IS_HIDDEN (state, bool) {
    state.isHidden = bool
  },
  SET_DOING_LOGIN (state, isLogin) {
    state.isLogin = isLogin
  },
  SET_LOGIN_MENUS (state, menus) {
    if (menus) {
      sessionStorage.setItem('menus', JSON.stringify(menus))
    } else {
      sessionStorage.removeItem('menus')
    }
    state.menus = menus
  },
  SET_LOGIN_USER (state, user) {
    if (user) {
      sessionStorage.setItem('user', user)
    } else {
      sessionStorage.removeItem('user')
    }
  },
  SET_LOGIN_TOKEN (state, token) {
    if (token) {
      sessionStorage.setItem('token', 'Bearer '+token)
    } else {
      sessionStorage.removeItem('token')
    }
  },
  SET_LOGIN_BUTTON (state, button) {
    if (button) {
      sessionStorage.setItem('button', button)
    } else {
      sessionStorage.removeItem('button')
    }
  }
}

const actions = {
  setUnReadCount ({commit}) {
    Axios.get(messageUnreadCountURL)
      .then(res => {
        if (res.msg) {
          this.$message({
            message: res.msg,
            type: 'warning'
          });
        } else{
          if (res != 0) {
            commit('SET_IS_HIDDEN', false)
          }
          commit('SET_UNREAD_COUNT', res)
        }         
      })
      .catch(err => {
        console.log(err)
      })
  },
  async login ({commit}, user) {
    commit('SET_DOING_LOGIN', true)
    // 登陆
    var res = await new Promise((resolve, reject) => {
      Axios.post(loginURL, user)
        .then(res => {
          commit('SET_DOING_LOGIN', false)
          if (res.msg) {
            alert(res.msg)
          } else {
            commit('SET_LOGIN_USER', JSON.stringify(res.user))
            commit('SET_LOGIN_TOKEN', res.token)
            commit('SET_LOGIN_MENUS', res.menus)          
            commit('SET_LOGIN_BUTTON', JSON.stringify(res.buttons))    
            // console.log(res.buttons)      
            resolve()
          }
        }).catch(err => {
          console.log(err)
          commit('SET_DOING_LOGIN', false)
        })
    })
  },
  async getLoginUser ({commit}) {
    // 模拟请求用户信息
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        var user = sessionStorage.getItem('user')
        // console.log(JSON.parse(user))
        // commit('SET_LOGIN_USER', JSON.stringify(user))
        resolve({bool: true, user})
      }, 1000)
    })
  },
  async logout ({commit}) {
    // 模拟退出
    // var res = await Vue.http.get(loginOutURL, {})
    // console.log(res)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('button')
        commit('SET_LOGIN_USER', null)
        resolve({bool: true})
      }, 1000)
    })
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/user.js